var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签名称" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入标签名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.tagName,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "tagName", $$v)
                            },
                            expression: "listPram.tagName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:order:tag:add"],
                      expression: "['admin:order:tag:add']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerOpenEdit(0)
                    },
                  },
                },
                [_vm._v("新增标签")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "id", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tagName",
                  label: "标签名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCount",
                  label: "订单数量",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                            "inactive-text": "禁用",
                            disabled: !_vm.checkPermi([
                              "admin:order:tag:status",
                            ]),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(
                                scope.row,
                                scope.row.status
                              )
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:tag:detail"],
                                expression: "['admin:order:tag:detail']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看订单")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:tag:update"],
                                expression: "['admin:order:tag:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:tag:delete "],
                                expression: "['admin:order:tag:delete ']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditTag", {
        ref: "EditTagRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("TagRecord", {
        ref: "TagRecordRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }